import { CdkStepper } from '@angular/cdk/stepper';
import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  QueryList,
} from '@angular/core';
import { merge, startWith, takeUntil } from 'rxjs';

import { ExpansionStepComponent } from './expansion-step.component';

@Component({
    selector: 'lui-expansion-stepper',
    templateUrl: './expansion-stepper.component.html',
    providers: [{ provide: CdkStepper, useExisting: ExpansionStepperComponent }],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ExpansionStepperComponent
  extends CdkStepper
  implements AfterContentInit
{
  /** Full list of steps inside the stepper, including inside nested steppers. */
  @ContentChildren(ExpansionStepComponent)
  override _steps!: QueryList<ExpansionStepComponent>;

  override readonly steps: QueryList<ExpansionStepComponent> =
    new QueryList<ExpansionStepComponent>();

  override ngAfterContentInit() {
    this._steps.changes
      .pipe(startWith(this._steps), takeUntil(this._destroyed))
      .subscribe((steps: QueryList<ExpansionStepComponent>) => {
        this.steps.reset(steps.filter((step) => step._stepper === this));
        this.steps.notifyOnChanges();
      });

    this.toggleExpansionDisabledState();

    merge(...this.steps.map((step) => step.stepCompleted), this.steps.changes)
      .pipe(takeUntil(this._destroyed))
      .subscribe(() => {
        this.toggleExpansionDisabledState();
        this._stateChanged();
      });
  }

  private toggleExpansionDisabledState() {
    this.steps.forEach((step, i) => {
      const isBlocked = this._isBlocked(i);

      step.toggleDisabled(isBlocked);
    });
  }

  private _isBlocked(index: number): boolean {
    if (this.linear && index >= 0) {
      return this.steps
        .toArray()
        .slice(0, index)
        .some((step) => {
          const control = step.stepControl;

          // const isIncomplete = control
          //   ? control.invalid || control.pending || !step.interacted
          //   : step._completedOverride !== null
          //   ? !step.completed
          //   : false;

          const isIncomplete = control
            ? control.invalid || control.pending || !step.interacted
            : !step.completed;

          return isIncomplete && !step.optional;
        });
    }

    return false;
  }
}
